import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function GridIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M2.558 2.536C.48 4.6.48 11.315 2.558 13.334a8.16 8.16 0 0 0 5.397 1.551 8.16 8.16 0 0 0 5.397-1.55c2.078-2.064 2.078-8.78 0-10.799C11.275.517 4.62.46 2.558 2.536Zm0 16.094c-2.077 2.064-2.077 8.78 0 10.798a8.16 8.16 0 0 0 5.397 1.551 8.16 8.16 0 0 0 5.397-1.55c2.078-2.064 2.078-8.78 0-10.798-2.077-2.02-8.732-2.078-10.794 0Zm21.487-3.745a8.16 8.16 0 0 0 5.397-1.55c2.077-2.064 2.077-8.78 0-10.799s-8.776-2.077-10.794 0c-2.019 2.078-2.078 8.779 0 10.798a8.16 8.16 0 0 0 5.397 1.551Zm-5.397 3.745c-2.078 2.064-2.078 8.78 0 10.798a8.16 8.16 0 0 0 5.397 1.551 8.16 8.16 0 0 0 5.397-1.55c2.077-2.064 2.077-8.78 0-10.798-2.077-2.02-8.732-2.078-10.794 0Z"
      />
    </BaseIcon>
  );
}
